import SDKMessageBus from '../utility/message-bus';
import { filter, mapTo, debounceTime } from 'rxjs/operators';

export default function cacheClearedSetup(
    messageBus: SDKMessageBus,
    teardowns: (() => void)[],
    platformCapabilities: Set<string>
) {
    if (!platformCapabilities.has('cacheCleared')) {
        return;
    }

    return function cacheCleared(route: string, callback: () => void): () => void {
        const sub = messageBus
            .onBroadcast<{ cleared: string }>(`cacheCleared`)
            .pipe(
                filter(message => route.indexOf(message.value.cleared) === 0),
                mapTo(undefined),
                debounceTime(300)
            )
            .subscribe(callback);
        const unsub = () => sub.unsubscribe();
        teardowns.push(unsub);

        return unsub;
    };
}
